import { StyleSheet, View, Text } from "react-native";
import SimplePress from "./SimplePress";
import SensorBranchSubitem from "./SensorBranchSubitem";
import { getSchemeStyle } from "../context/helper";

const SensorBranchItem = (props) => {
  const schemeStyles = getSchemeStyle();

  return (
    <SimplePress onPress={props.onPress}>
      <View style={[styles.itemContainer,schemeStyles.BorderC]}>
        <View style={styles.textContainer}>
          <Text style={[styles.itemText,schemeStyles.grayText]}>{props.item.name}</Text>
        </View>
        {props.item.data.map((data) => (
            <SensorBranchSubitem key={data.id} item={data} />
          ))}
      </View>
    </SimplePress>
  );
};

export default SensorBranchItem;

const styles = StyleSheet.create({
  itemContainer: {
    alignItems: "center",
    flex: 1,
    marginBottom: 15,
    borderBottomWidth: 2,
  },
  textContainer: {
    flex: 1,
    flexDirection: 'row'
  },
  itemText: {
    fontFamily: "Roboto-MediumItalic",
    fontSize: 18,
    marginLeft: 5,
    flex: 1
  },
});
